import { useState } from "react";
import { Box, Card, CardActions, CardContent, Container, Grid, Pagination, Typography } from "@mui/material";
import { IReportsListProps } from "../types/interfaces/IReportsListProps";
import { IReport } from "../types/interfaces/IReport";
import { ReportsListAction } from "./ReportsListAction";

//This component is responsible for displaying a list of the reports.
export const ReportsList: React.FC<IReportsListProps> = ({ reports, onView }) => {
    if (!reports || reports.length === 0) return null;
    
    const [page, setPage] = useState(1);
    const reportsPerPage = 3;
    const count = Math.ceil(reports.length/reportsPerPage);

    //Function to handle the page change.
    const pageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    return (
        <Container>
            <Typography variant="h6" color="black" component="div">
                <Box sx={{ fontWeight: 'bold', mt:1 }}>Report List</Box>
            </Typography>
            <Grid container spacing={1} sx={{mt:1}}>
                {reports.slice((page - 1) * reportsPerPage, page * reportsPerPage).map((report: IReport[] | any ) => (
                    <Grid item xs={12} sm={6} md={4} key={report.ReportKey} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Card sx={{ border: 1, borderColor: 'divider' }}>
                            <CardContent sx={{ paddingBottom: 0 }}>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="body2" fontWeight="bold" color="black" mr={1}>Title:</Typography>
                                    <Typography variant="body2" component="div" sx={{wordBreak: 'break-word'}}>{report.Title}</Typography>
                                </Box>
                                {report.Description &&
                                <Box display="flex" alignItems="center">
                                    <Typography variant="body2" fontWeight="bold" color="black" mr={1}>Description:</Typography>
                                    <Typography variant="body2" component="div" sx={{wordBreak: 'break-word'}}>{report.Description}</Typography>
                                </Box>
                                }
                            </CardContent>
                            <CardActions>
                                <ReportsListAction report={report} onView={onView} />
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Pagination count={count} page={page} onChange={pageChange} variant="outlined" shape="rounded" showFirstButton showLastButton sx={{mt:1, mb:5}} />
        </Container>
    );
};